export default __webpack_public_path__ + "static/media/3.951ef2db.jpg";